import React from 'react';
import './footerTitle.css';

const FooterTitle = (props) => {
    return ( 
        <>
        <span className='footerTitle body'>{props.footerTitle}</span>
        </>
     );
}
 
export default FooterTitle;